import _ from '@lodash';
import { AppBar, DialogActions, DialogContent, Icon, IconButton, ListItemIcon, ListItemText, Menu, MenuItem, TextField, Toolbar, Typography } from '@material-ui/core';
import XAPPButton from "app/Core/Components/Button/XAPPButton";
import XAPPDialog from "app/Core/Components/Dialog/XAPPDialog";
import XAPPComponent from 'app/Core/Components/XAPPComponent/XAPPComponent';
import MobileDetect from 'mobile-detect';
import React from 'react';
import { MdAdd, MdClose, MdLabel } from 'react-icons/md';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as Actions from '../Store/Actions/ComunicadorActions';

const md = new MobileDetect(window.navigator.userAgent);

class MensagemTag extends XAPPComponent {

    state = { tagMenuEl: null, dialog: null };

    handleChangeMenu = (_AValue) => {
        this.setState(_.set({ ...this.state }, "tagMenuEl", _AValue));
    };

    handleChangeTag = (_ATag) => {
        const { save, idmensagem } = this.props;
        save({ idmensagem: idmensagem, idtag: _ATag.idtag, idlocal: _ATag.idlocal }, "UPDATETAG");
    };

    isSelected = (_AValue) => {
        var { selected } = this.props;
        var AExists = false;
        !_.isNull(selected) && selected.forEach((id) => {
            if (id === _AValue.idtag) {
                AExists = true;
            }
        });
        return AExists;
    }

    openDialog = (_AValue = null) => {
        this.setState(_.set({ ...this.state }, "dialog", _AValue));
    }

    handleChange = (ev) => {
        this.setState(_.set({ ...this.state }, ev.target.name, ev.target.value));
    }

    canBeSubmitted = () => {
        const { dialog } = this.state;
        return (!_.isUndefined(dialog?.nome) && !_.isNull(dialog?.nome) && dialog?.nome !== "")
    }

    render() {

        const { tagMenuEl, dialog } = this.state;
        const { idmensagem, saveCustom, Tags = [], idlocal, xappRouteParams, callback } = this.props;
        return (
            <React.Fragment>
                <XAPPButton
                    aria-owns={tagMenuEl ? 'label-menu' : null}
                    aria-haspopup="true"
                    tooltip={{ "title": "Tags", "placement": "top" }}
                    type="Icon"
                    className="text-16"
                    onClick={ev => {
                        ev.stopPropagation();
                        this.handleChangeMenu(ev.currentTarget);
                    }}
                    icon={"label"}
                />
                <Menu
                    id="label-menu"
                    anchorEl={tagMenuEl}
                    open={Boolean(tagMenuEl)}
                    onClose={ev => {
                        ev.stopPropagation();
                        this.handleChangeMenu(null);
                    }}
                >
                    {!_.isNull(Tags) && Tags.map((tag) => (
                        <MenuItem
                            onClick={ev => {
                                ev.stopPropagation();
                                this.handleChangeTag(tag);
                            }}
                            key={"MenuItem_" + tag.idtag}
                        >
                            <ListItemIcon>
                                <Icon color="action">
                                    {this.isSelected(tag) ? 'check_box' : 'check_box_outline_blank'}
                                </Icon>
                            </ListItemIcon>
                            <ListItemIcon className="m-0">
                                <MdLabel color="action" />
                            </ListItemIcon>
                            <ListItemText primary={tag.nome} disableTypography={true} />
                        </MenuItem>
                    ))}
                    <MenuItem
                        onClick={ev => {
                            ev.stopPropagation();
                            this.openDialog({
                                idmensagemtag: null,
                                nome: "",
                                idlocal: idlocal
                            });
                        }}
                        key={"MenuItem_NovaTag"}
                    >
                        <ListItemIcon>
                            <MdAdd color="action" size={20} />
                        </ListItemIcon>
                        <ListItemText primary={"Adicionar tag"} disableTypography={true} />
                    </MenuItem>
                </Menu>
                <XAPPDialog
                    id="MensagemTag"
                    open={!_.isNull(dialog)}
                    onClose={() => this.openDialog()}
                    fullWidth
                    maxWidth="sm"
                >
                    <AppBar position="static" elevation={1}>
                        <Toolbar className="flex w-full min-h-0">
                            <Typography variant="subtitle1 text-white">
                                {!_.isNull(dialog) && !_.isNull(dialog.idmensagemtag) ? "Editar tag" : "Adicionar tag"}
                            </Typography>
                            <div style={{ flex: 1 }} />
                            <IconButton
                                key="close"
                                aria-label="Close"
                                className="p-6"
                                onClick={() => this.openDialog()}
                            >
                                <MdClose className="text-20 text-white" />
                            </IconButton>
                        </Toolbar>
                    </AppBar>
                    <DialogContent className="p-20 overflow-hidden">
                        <TextField
                            className=""
                            id={"dialog.nome"}
                            name={"dialog.nome"}
                            label={"Nome"}
                            value={dialog?.nome}
                            onChange={this.handleChange}
                            variant="outlined"
                            fullWidth
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                    </DialogContent>
                    <AppBar position="static" elevation={3} color="textSecondary">
                        <Toolbar className="flex w-full justify-end min-h-0 px-8">
                            <DialogActions>
                                <XAPPButton
                                    type="Button"
                                    className="bg-green hover:bg-green text-white mr-8"
                                    variant="contained"
                                    color="primary"
                                    onClick={() => {
                                        saveCustom({ ...dialog, idmensagem: idmensagem }, xappRouteParams, "INSERIRTAG", callback);
                                        this.openDialog();
                                    }}
                                    disabled={!this.canBeSubmitted()}
                                    iconProps={md.mobile() === null && md.tablet() === null ? "mr-8" : "justify-center"}
                                    icon={"save"}
                                    label={md.mobile() === null && md.tablet() === null ? "Salvar" : ""}
                                />
                            </DialogActions>
                        </Toolbar>
                    </AppBar>
                </XAPPDialog>
            </React.Fragment>
        );
    }
}



function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        saveCustom: Actions.saveCustom,
    }, dispatch);
}

function mapStateToProps({ Comunicador, fuse }) {
    return {
        Comunicador: Comunicador,
        theme: fuse.settings.mainTheme
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(MensagemTag);

